import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalService {
    constructor(private modalService: ModalService) {
        
      }
    private modals: any[] = [];
    public modalStatus: Subject<any> = new Subject<any>();

    add(modal: any) {
        // add modal to array of active modals
        this.modals.push(modal);
    }

    remove(id: string) {
        // remove modal from array of active modals
        this.modals = this.modals.filter(x => x.id !== id);
    }

    open(id: string) {
        // open modal specified by id
        console.log('ModalService.open called with id:', id);
        console.log('Available modals:', this.modals.map(m => m.id));
        
        let modal: any = this.modals.filter(x => x.id === id)[0];
        if (modal) {
            console.log('Opening modal:', id);
            modal.open();
        } else {
            console.error('Modal not found:', id);
        }
    }

    close(id: string) {
        // close modal specified by id
        let modal: any = this.modals.filter(x => x.id === id)[0];
       
        modal.close();
    }
}